import {FC, useState} from 'react';
import {Box, Button, Flex, IconButton, Stack} from '@chakra-ui/react';
import {api, useT} from '@kcast-fe/core';
import {copyToClipboard, toastUtils} from 'core';
import {ConfirmDialog, Input, Svg} from 'ui-kit';

export const LiveStreamSettings: FC = () => {
  const {data} = api.cameras.useCameraStreamSettingsQuery();
  const regenerateMutation = api.cameras.useRegenerateCameraStreamKeyMutation();

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const {t} = useT();

  const camera = data?.cameras[0];

  if (!data || !camera) {
    return null;
  }

  const handleCopy = async (value: string) => {
    if (await copyToClipboard(value)) {
      toastUtils.success({message: t('cameraStream.copied'), icon: 'Check'});
    }
  };

  const handleRegenerate = () => {
    regenerateMutation.mutate(camera.id, {
      onSuccess: () => setIsConfirmOpen(false),
      onError: () => toastUtils.error({message: t('errors.wentWrong')})
    });
  };

  return (
    <Stack gap={'8px'}>
      <Box p={'0 4px'}>{t('cameraStream.title')}</Box>
      <Flex gap={'8px'} alignItems={'center'}>
        <Box flex={'1 1 auto'} minW={0}>
          <Input disabled value={data.rtmps_url} aria-label={t('cameraStream.serverUrl')} />
        </Box>
        <IconButton
          variant={'ghost'}
          aria-label={t('cameraStream.copyUrl')}
          onClick={() => handleCopy(data.rtmps_url)}
        >
          <Svg name={'Copy'} size={'s20'} />
        </IconButton>
      </Flex>

      <Flex gap={'12px'} flexWrap={'wrap'}>
        <Button size={'sm'} variant={'subtle'} onClick={() => handleCopy(camera.stream_key)}>
          {t('cameraStream.copyKey')}
        </Button>
        <Button
          size={'sm'}
          variant={'subtle'}
          disabled={regenerateMutation.isPending}
          onClick={() => setIsConfirmOpen(true)}
        >
          {t('cameraStream.regenerate')}
        </Button>
      </Flex>

      <ConfirmDialog
        isOpen={isConfirmOpen}
        title={t('cameraStream.regenerate')}
        body={t('cameraStream.regenerateConfirm')}
        confirmLabel={t('cameraStream.regenerate')}
        variant={'danger'}
        isLoading={regenerateMutation.isPending}
        onConfirm={handleRegenerate}
        onCancel={() => setIsConfirmOpen(false)}
      />
    </Stack>
  );
};
